var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.8 10.6C9.3464 10.6 10.6 9.3464 10.6 7.8C10.6 6.2536 9.3464 5 7.8 5C6.2536 5 5 6.2536 5 7.8C5 9.3464 6.2536 10.6 7.8 10.6Z","fill":"black","key":0}),React.createElement("path",{"d":"M16.2 10.6C17.7464 10.6 19 9.3464 19 7.8C19 6.2536 17.7464 5 16.2 5C14.6536 5 13.4 6.2536 13.4 7.8C13.4 9.3464 14.6536 10.6 16.2 10.6Z","fill":"black","key":1}),React.createElement("path",{"d":"M10.6 16.2C10.6 17.7464 9.3464 19 7.8 19C6.2536 19 5 17.7464 5 16.2C5 14.6536 6.2536 13.4 7.8 13.4C9.3464 13.4 10.6 14.6536 10.6 16.2Z","fill":"black","key":2}),React.createElement("path",{"d":"M16.2 19C17.7464 19 19 17.7464 19 16.2C19 14.6536 17.7464 13.4 16.2 13.4C14.6536 13.4 13.4 14.6536 13.4 16.2C13.4 17.7464 14.6536 19 16.2 19Z","fill":"black","key":3})]);
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
